<template>
  <div>
    <jet-dialog-modal :show="openModal" @close="closeModal">
      <template #title>
        <p class="font-bold text-center text-xl">เผยแพร่แบนเนอร์?</p>
      </template>

      <template #content>
        <div class="mt-4" v-if="!lastVersion">
          <div
            class="
              col-span-12
              px-6
              py-3
              my-2
              rounded
              border border-yr-primary-ii-300
              bg-yr-primary-50
            "
          >
            <p class="text-center mb-1 font-medium">
              คุณจะเผยแพร่แบนเนอร์ในเวอร์ชั่น {{ version.version + 1 }}
            </p>
            <p class="text-center text-sm text-yr-primary-ii-500">
              แบนเนอร์เวอร์ชั่นปัจจุบันเป็นเวอร์ชั่น
              {{ version.version }} CookiePop จะกำหนดเลขเวอร์ชันโดยอัตโนมัติ
            </p>
          </div>
          <label class="flex justify-center items-center mb-5">
            <input
              class="mr-2 leading-tight"
              type="checkbox"
              name="isNew"
              id="isNew"
              v-model="isNew"
              @input="setIsNew"
            />
            <span class="text-sm">
              ต้องการให้แบนเนอร์คุกกี้ขึ้นมาขอความยินยอมผู้เยี่ยมชมเว็บไซต์ใหม่อีกครั้ง
            </span>
          </label>
          <div class="w-full flex justify-center">
            <jet-button
              @click="publishVersion"
              class="
                cursor-pointer
                inline-flex
                items-center
                px-4
                py-2
                bg-yr-primary-ii-500
                border border-transparent
                rounded-md
                font-semibold
                text-xs text-white
                uppercase
                tracking-widest
                hover:bg-yr-primary-ii-600
                active:bg-yr-primary-ii-700
                focus:outline-none
                focus:border-yr-primary-ii-700
                focus:ring
                focus:ring-yr-primary-ii-300
                transition
              "
            >
              เผยแพร่
            </jet-button>
          </div>
        </div>
        <div class="mt-4" v-else>
          <div
            class="
              col-span-12
              px-6
              py-3
              my-2
              rounded
              border border-yr-primary-ii-300
              bg-yr-primary-50
            "
          >
            <p class="text-center mb-1 font-medium">
              แบนเนอร์ไม่มีการเปลี่ยนแปลง
            </p>
          </div>
        </div>
      </template>

      <template #footer>
        <jet-secondary-button @click="closeModal"> ปิด </jet-secondary-button>
      </template>
    </jet-dialog-modal>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import JetDialogModal from "@/Jetstream/DialogModal.vue";
import JetButton from "@/Jetstream/Button.vue";
import JetSecondaryButton from "@/Jetstream/SecondaryButton.vue";

export default defineComponent({
  props: ["openModal", "version", "lastVersion"],

  components: {
    JetDialogModal,
    JetButton,
    JetSecondaryButton,
  },

  data() {
    return {
      isNew: false,
      //   form: this.$inertia.form({
      //     domain_name: null,
      //   }),
    };
  },

  methods: {
    publishVersion() {
      axios
        .post(route("publish.version"), {
          id: this.version.project_id,
          version: this.version.version,
          isNew: this.isNew,
        })
        .then(() => {
          this.closeModal();
          this.$emit("update-status");
        })
        .catch((error) => {});
    },

    setIsNew() {
      this.isNew = this.isNew ? false : true;
    },

    closeModal() {
      //   this.form.reset();
      this.$emit("close-modal");
    },
  },

  watch: {
    openModal(value) {
      //   if (value) //open
      //     setTimeout(() => this.$refs.domain_name.focus(), 250);
    },
  },
});
</script>
